var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding-top":"5px"}},[_c('v-chip',{staticClass:"primary--text",attrs:{"small":""},on:{"click":_vm.changeStorageDialog}},[_c('v-icon',{staticClass:"mr-2"},[_vm._v("edit")]),_vm._v(" change storage ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }